<section class="content tab-section d-flex">
  <div class="content-block flex-grow-1">

    <div class="tab-content flex-grow-1 position-relative" *ngIf="isSpinnerLoading">
      <div class="custom-loader"></div>
    </div>
    <div class="row flex-grow-1 main-box " *ngIf="!isSpinnerLoading && courseData">
      <!-- if informational course then view in whole screen or else not -->
      <div class="l-box d-flex flex-column" [ngClass]="courseData.is_info==1?'col-12':'col-lg-6 col-xl-7 '">
        <div class="c-img" [appBackgroundImg]="courseData.img" [iType]="'course'">
          <div class="back-btn d-flex align-items-center text-semibold cursor-pointer" (click)="onBack()">
            <i class="material-icons me-1">keyboard_backspace</i> Back
          </div>
        </div>
        <div class="c-content flex-grow-1 mt-4 c-lbox ">
          <div class="d-flex justify-content-between  align-items-center flex-wrap">
            <div class="mt-3">
              <div class="heading-2">{{courseData.tit}}</div>
              <div class="small-text grey2 mt-1">{{courseData.dep}} </div>
              <div class="me-3 mt-3 d-flex align-items-center" *ngIf="courseType!='m_cs'">
                <img src="assets/images/package/price.png" class="img-fluid me-1" />
                <span class="heading-2">€{{courseData.pr}}</span>
              </div>
            </div>
            <div class="d-flex align-items-center flex-wrap " *ngIf="courseType!='m_cs'">
              
             <div class="d-flex flex-wrap">

              <button
              class="btn c-btn btn-outline-primary outline-btn no-sh-btn mt-3 me-3 d-flex align-items-center justify-content-center"
              type="submit" (click)="onCoursePreview()">
              <i class="material-icons me-1">remove_red_eye</i>Preview</button>

              <button mat-raised-button color="primary" class="primary-btn c-btn no-sh-btn mt-3 me-2" type="submit"
              (click)="onBuyCourse(courseData.id,courseData)">
              <mat-icon class="kt-margin-r-0">shopping_cart</mat-icon> Buy</button>

             </div>
            </div>
            <div class="d-flex align-items-center flex-wrap " *ngIf="courseType=='m_cs'">
              <button type="button" (click)="onSubSectionNew()"
                class="btn c-btn btn-outline-primary outline-btn justify-content-center d-flex mt-3 align-items-center pre-btn">
                {{"Start Course" |translate}}</button>

            </div>
          </div>
          <div class="ql-snow mt-4 pt-xl-3 cont-desc" >
            <div class="ql-editor " [innerHtml]="courseData.desc|safe:'html'"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-5 r-box d-flex flex-column " *ngIf="courseData.is_info==0">
        <div class="c-content flex-grow-1 course-section mt-4 mt-lg-0">
          <div class="d-flex align-items-center text-medium justify-content-between ">
            <div class="text-semibold text-black ">Course Section</div>
            <div class="view-div cursor-pointer">
              <div (click)="onExpandAll()" *ngIf="!isExpandAll">Exapnd All <img class="ms-2"
                  src="assets/images/icons/expand-all.svg" alt=""></div>
              <div (click)="onExpandAll()" *ngIf="isExpandAll">Collapse All <img class="ms-2"
                  src="assets/images/icons/collapse-all.svg" alt=""></div>
            </div>
          </div>

          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
            *ngFor="let item of sectionArr;let i=index" [expanded]="isExpandAll">
            <mat-expansion-panel-header class="ti-box medium-sans">
              <mat-panel-title class="se-b d-flex medium-sans">
                <div class="num-box me-2 ">{{i+1}}.</div>
                <div class="panel-title">{{item.s_tit}}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="template-content-box pb-2">
              <div class="item-box d-flex " *ngFor="let value of item.sub_s;let j=index"
                (click)="onSubSection(item.s_i,value,item)">
                <div class="d-flex justify-content-between pt-4 w-100">
                  <div class="d-flex align-items-center ">
                    <div class="object-icon me-2">
                      <img *ngIf="value.type=='text'" src="assets/images/object_icons/text.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='audio'" src="assets/images/object_icons/audio.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='video'" src="assets/images/object_icons/video.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='youtube'" src="assets/images/object_icons/youtube.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='pdf'" src="assets/images/object_icons_new/pdf.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="(value.type=='file')||(value.type=='image')" src="assets/images/object_icons/file.svg"
                        class="img-fluid" alt="">
                      <img *ngIf="value.type=='link'" src="assets/images/object_icons/link.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='exam'" src="assets/images/object_icons/quiz.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='iframe'" src="assets/images/object_icons/iframe.svg" class="img-fluid"
                        alt="">
                    </div>
                    <div *ngIf="value.sub_tit" class="subs-txt">{{value.sub_tit}}</div>
                    <div *ngIf="!value.sub_tit" class="subs-txt">Sub section {{j+1}}</div>
                  </div>
                  <div *ngIf="value.is_cp==1">
                    <img src="assets/images/icons/tick_mark.svg" class="img-fluid" alt="">
                  </div>
                </div>

              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
    <div class="mat-table__message" *ngIf="!isSpinnerLoading && !courseData">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
    </div>
  </div>
</section>